
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { StepOneModel } from '../../../shared/models/states/loan-step-one.model';

export type LinkedPrimaryApplicantInfo = {
    full_name: string;
    email: string | null;
    phone: string | null;
};

@Injectable({
    providedIn: 'root',
})
export class LoanApplicationService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/loan_applications`;

    // Create an application
    createLoanApplication(application: StepOneModel): Observable<StepOneModel> {
        return this.post(this.apiUrl, application);
    }

    // Read all applications
    getLoanApplications(): Observable<StepOneModel[]> {
        return this.get(this.apiUrl);
    }

    // Read a single application by ID
    getLoanApplicationById(id: string): Observable<StepOneModel> {
        return this.get(`${this.apiUrl}/loan_uuid/${id}`);
    }

    getLinkedPrimaryApplicant(nonjointLoanId: string): Observable<LinkedPrimaryApplicantInfo> {
        return this.get(`${this.apiUrl}/nonjoint-linked-primary/${nonjointLoanId}`);
    }

    // Update an application
    updateLoanApplication(id: string, application: StepOneModel): Observable<StepOneModel> {
        return this.put(`${this.apiUrl}/${id}`, application);
    }

    // Patch progress (highest_completed_step, next_required_field)
    patchProgress(loanId: string, payload: { highest_completed_step?: number; next_required_field?: string | null }): Observable<StepOneModel> {
        return this.patch(`${this.apiUrl}/${loanId}/progress`, payload);
    }

    // Delete an application
    deleteLoanApplication(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }
}
